import styled from "@emotion/styled";

export const AppNavbarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 4rem;
  background-color: ${(p) => p.theme.colors.background};
  box-shadow: ${(p) => p.theme.shadows.primary};

  ${(p) => p.theme.media.mobileDown} {
    justify-content: flex-start;
    min-height: 4.5rem;
  }
`;

export const ExpandButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  left: 0.5rem;
  top: 0;

  ${(p) => p.theme.media.mobileDown} {
    position: relative;
  }
`;

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  right: 1rem;
  top: 0;
  color: ${(p) => p.theme.text.colors.primary};
`;
